module.exports = __webpack_public_path__ + "static/img/zalo-seeklogo.com.9087cf4a.svg";